import type { HelpFile } from '../../types/help'
import { SchemaPoliciesTestIds } from '../../../testids/SchemaPoliciesTestIds'

export const schemaPoliciesHelp: HelpFile = {
  docPage: '/docs/schema/policies',
  texts: {
    [SchemaPoliciesTestIds.schemaPoliciesList]:
      'Schema-Richtlinien — deklarative Invarianten, die das Substrat gegen Parties, Identitäten und Attribute auswertet. In Kombination mit der Verstoßliste werden Drifts behoben.',
    [SchemaPoliciesTestIds.btnCreatePolicy]:
      'Eine neue Richtlinie aus einem CEL-Ausdruck erstellen oder einen registrierten Native-Code-Producer einbinden.',
    [SchemaPoliciesTestIds.colName]: 'Global eindeutiger kebab-case-Name; erscheint als Richtlinien-Spalte in den Verstößen.',
    [SchemaPoliciesTestIds.colType]: 'DSL wertet den CEL-Ausdruck zur Erkennungszeit aus; NATIVE_CODE delegiert an einen registrierten Java-Producer.',
    [SchemaPoliciesTestIds.colSeverity]: 'Bestimmt Badge-Farbe und Reihenfolge in Verstoßlisten.',
    [SchemaPoliciesTestIds.colEnabled]: 'Deaktivierte Richtlinien werden im Start-of-Day-Lauf übersprungen, bleiben aber für die Historie erhalten.',
    [SchemaPoliciesTestIds.colLastReviewed]: 'Letzte Überprüfung der Richtlinie durch einen Admin. Überprüfungen halten die Richtlinie aus der Überfällig-Triage heraus.',
    [SchemaPoliciesTestIds.colViolations]: 'Anzahl offener Verstöße für diese Richtlinie.',
  },
}
